import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SeamlessForm from './pages/0_InitialPromoPage/InitialPromoPage';
import IdentifyRestaurant from './pages/1_IdentifyRestaurant/IdentifyRestaurant';
import Menus from './pages/2_Menu/Menu';
import YourInfo from './pages/3_YourInfo/YourInfo';
import CustomerOrder from './pages/4_CustomerOrder/CustomerOrder';
import FinalPage from './pages/5_FinalPage/FinalPage';
import AgentEnding from './pages/6_AgentEnding/AgentEnding';
import updateState from './actions/updateState';

const App = () => {
  const step = useSelector((state) => state.formState.step);
  const dispatch = useDispatch();

  useEffect(() => {
    if (process.env.REACT_APP_ENV === 'dev') {
      dispatch(
        updateState({
          baseURL: 'https://9v8upsmsai.execute-api.us-east-1.amazonaws.com/dev',
        })
      );
    } else if (process.env.REACT_APP_ENV === 'prod') {
      dispatch(
        updateState({
          baseURL:
            'https://9v8upsmsai.execute-api.us-east-1.amazonaws.com/prod',
        })
      );
    } else {
      dispatch(
        updateState({
          baseURL: 'NO ENVIRONMENT SPECIFIED',
        })
      );
    }
  }, []);

  switch (step) {
    case 0:
      return <SeamlessForm />;
    case 1:
      return <IdentifyRestaurant />;
    case 2:
      return <Menus />;
    case 3:
      return <YourInfo />;
    case 4:
      return <CustomerOrder />;
    case 5:
      return <FinalPage />;
    case 6:
      return <AgentEnding />;
    default:
      return <SeamlessForm />;
  }
};

export default App;
